import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  IdRsp,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from '../common';
import {Amenity, AmenityCreateReq, Amenities, AmenityUpdateReq, AvailabilityResponse, AvailabilityRangeResponse} from '../types/amenity';

/**
 * AmenityServiceApi - axios parameter creator
 * @export
 */
export const AmenityServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 创建
     * @summary 创建
     * @param {AmenityCreateReq} amenityCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    amenityServiceCreate: async (
      amenityCreateReq: AmenityCreateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'amenityCreateReq' is not null or undefined
      assertParamExists('amenityServiceCreate', 'amenityCreateReq', amenityCreateReq);
      const localVarPath = `/amenity/amenity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        amenityCreateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 删除
     * @summary 删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    amenityServiceDelete: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('amenityServiceDelete', 'id', id);
      const localVarPath = `/amenity/amenity/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 详情
     * @summary 详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    amenityServiceDetail: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('amenityServiceDetail', 'id', id);
      const localVarPath = `/amenity/amenity/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 查询
     * @summary 查询
     * @param {string} [orgId]
     * @param {string} [apartmentId]
     * @param {Array<string>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    amenityServiceFind: async (
      orgId?: string,
      apartmentId?: string,
      ids?: Array<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/amenity/amenities`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (apartmentId !== undefined) {
        localVarQueryParameter['apartmentId'] = apartmentId;
      }

      if (ids) {
        localVarQueryParameter['ids'] = ids;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 修改
     * @summary 修改
     * @param {string} id
     * @param {AmenityUpdateReq} amenityUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    amenityServiceGetAvailability: async (
      id: string,
      date: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      assertParamExists('amenityServiceGetAvailability', 'id', id);
      assertParamExists('amenityServiceGetAvailability', 'date', date);
      const localVarPath = `/amenity/amenities/{id}/availability`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (date !== undefined) {
        localVarQueryParameter['date'] = date;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    amenityServiceGetAvailabilityRange: async (
      id: string,
      startDate: string,
      endDate: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      assertParamExists('amenityServiceGetAvailabilityRange', 'id', id);
      const localVarPath = `/amenity/amenities/{id}/availability`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      localVarQueryParameter['date'] = startDate;
      localVarQueryParameter['endDate'] = endDate;
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    amenityServiceUpdate: async (
      id: string,
      amenityUpdateReq: AmenityUpdateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('amenityServiceUpdate', 'id', id);
      // verify required parameter 'amenityUpdateReq' is not null or undefined
      assertParamExists('amenityServiceUpdate', 'amenityUpdateReq', amenityUpdateReq);
      const localVarPath = `/amenity/amenity/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        amenityUpdateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AmenityServiceApi - functional programming interface
 * @export
 */
export const AmenityServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AmenityServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * 创建
     * @summary 创建
     * @param {AmenityCreateReq} amenityCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async amenityServiceCreate(
      amenityCreateReq: AmenityCreateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.amenityServiceCreate(
        amenityCreateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AmenityServiceApi.amenityServiceCreate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 删除
     * @summary 删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async amenityServiceDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.amenityServiceDelete(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AmenityServiceApi.amenityServiceDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 详情
     * @summary 详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async amenityServiceDetail(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Amenity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.amenityServiceDetail(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AmenityServiceApi.amenityServiceDetail']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 查询
     * @summary 查询
     * @param {string} [orgId]
     * @param {string} [apartmentId]
     * @param {Array<string>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async amenityServiceFind(
      orgId?: string,
      apartmentId?: string,
      ids?: Array<string>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Amenities>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.amenityServiceFind(
        orgId,
        apartmentId,
        ids,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AmenityServiceApi.amenityServiceFind']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 修改
     * @summary 修改
     * @param {string} id
     * @param {AmenityUpdateReq} amenityUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async amenityServiceGetAvailability(
      id: string,
      date: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.amenityServiceGetAvailability(
        id,
        date,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AmenityServiceApi.amenityServiceGetAvailability']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    async amenityServiceGetAvailabilityRange(
      id: string,
      startDate: string,
      endDate: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityRangeResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.amenityServiceGetAvailabilityRange(id, startDate, endDate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AmenityServiceApi.amenityServiceGetAvailabilityRange']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    async amenityServiceUpdate(
      id: string,
      amenityUpdateReq: AmenityUpdateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.amenityServiceUpdate(
        id,
        amenityUpdateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AmenityServiceApi.amenityServiceUpdate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AmenityServiceApi - factory interface
 * @export
 */
export const AmenityServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AmenityServiceApiFp(configuration);
  return {
    /**
     * 创建
     * @summary 创建
     * @param {AmenityCreateReq} amenityCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    amenityServiceCreate(amenityCreateReq: AmenityCreateReq, options?: any): AxiosPromise<IdRsp> {
      return localVarFp
        .amenityServiceCreate(amenityCreateReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 删除
     * @summary 删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    amenityServiceDelete(id: string, options?: any): AxiosPromise<void> {
      return localVarFp.amenityServiceDelete(id, options).then(request => request(axios, basePath));
    },
    /**
     * 详情
     * @summary 详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    amenityServiceDetail(id: string, options?: any): AxiosPromise<Amenity> {
      return localVarFp.amenityServiceDetail(id, options).then(request => request(axios, basePath));
    },
    /**
     * 查询
     * @summary 查询
     * @param {string} [orgId]
     * @param {string} [apartmentId]
     * @param {Array<string>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    amenityServiceFind(
      orgId?: string,
      apartmentId?: string,
      ids?: Array<string>,
      options?: any
    ): AxiosPromise<Amenities> {
      return localVarFp
        .amenityServiceFind(orgId, apartmentId, ids, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 修改
     * @summary 修改
     * @param {string} id
     * @param {AmenityUpdateReq} amenityUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    amenityServiceGetAvailability(
      id: string,
      date: string,
      options?: any
    ): AxiosPromise<AvailabilityResponse> {
      return localVarFp
        .amenityServiceGetAvailability(id, date, options)
        .then(request => request(axios, basePath));
    },
    amenityServiceGetAvailabilityRange(
      id: string,
      startDate: string,
      endDate: string,
      options?: any
    ): AxiosPromise<AvailabilityRangeResponse> {
      return localVarFp
        .amenityServiceGetAvailabilityRange(id, startDate, endDate, options)
        .then(request => request(axios, basePath));
    },
    amenityServiceUpdate(
      id: string,
      amenityUpdateReq: AmenityUpdateReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .amenityServiceUpdate(id, amenityUpdateReq, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AmenityServiceApi - object-oriented interface
 * @export
 * @class AmenityServiceApi
 * @extends {BaseAPI}
 */
export class AmenityServiceApi extends BaseAPI {
  /**
   * 创建
   * @summary 创建
   * @param {AmenityCreateReq} amenityCreateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AmenityServiceApi
   */
  public amenityServiceCreate(amenityCreateReq: AmenityCreateReq, options?: RawAxiosRequestConfig) {
    return AmenityServiceApiFp(this.configuration)
      .amenityServiceCreate(amenityCreateReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 删除
   * @summary 删除
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AmenityServiceApi
   */
  public amenityServiceDelete(id: string, options?: RawAxiosRequestConfig) {
    return AmenityServiceApiFp(this.configuration)
      .amenityServiceDelete(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 详情
   * @summary 详情
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AmenityServiceApi
   */
  public amenityServiceDetail(id: string, options?: RawAxiosRequestConfig) {
    return AmenityServiceApiFp(this.configuration)
      .amenityServiceDetail(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 查询
   * @summary 查询
   * @param {string} [orgId]
   * @param {string} [apartmentId]
   * @param {Array<string>} [ids]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AmenityServiceApi
   */
  public amenityServiceFind(
    orgId?: string,
    apartmentId?: string,
    ids?: Array<string>,
    options?: RawAxiosRequestConfig
  ) {
    return AmenityServiceApiFp(this.configuration)
      .amenityServiceFind(orgId, apartmentId, ids, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 修改
   * @summary 修改
   * @param {string} id
   * @param {AmenityUpdateReq} amenityUpdateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AmenityServiceApi
   */
  public amenityServiceGetAvailability(id: string, date: string, options?: RawAxiosRequestConfig) {
    return AmenityServiceApiFp(this.configuration)
      .amenityServiceGetAvailability(id, date, options)
      .then(request => request(this.axios, this.basePath));
  }

  public amenityServiceGetAvailabilityRange(id: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
    return AmenityServiceApiFp(this.configuration)
      .amenityServiceGetAvailabilityRange(id, startDate, endDate, options)
      .then(request => request(this.axios, this.basePath));
  }

  public amenityServiceUpdate(
    id: string,
    amenityUpdateReq: AmenityUpdateReq,
    options?: RawAxiosRequestConfig
  ) {
    return AmenityServiceApiFp(this.configuration)
      .amenityServiceUpdate(id, amenityUpdateReq, options)
      .then(request => request(this.axios, this.basePath));
  }
}
